import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem("mms_user");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mms_token", data.access_token);
    localStorage.setItem("mms_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("mms_token");
    localStorage.removeItem("mms_user");
    setUser(null);
  }, []);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("mms_token");
    if (!token) return null;
    setLoading(true);
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("mms_user", JSON.stringify(data));
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem("mms_token");
      localStorage.removeItem("mms_user");
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("mms_token") && !user) {
      refresh();
    }
  }, [refresh, user]);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
